export interface InsightDetailSelectionProps {
    selectedSlides: Set<number>;
    setSelectedSlides: (e: Set<number>) => void;
}

export enum InsightDetailType {
    VIEW = "VIEW",
    SELECTION = "SELECTION",
}

export interface InsightDetailViewOption {
    type: InsightDetailType.VIEW;
    component: React.FunctionComponent;
}

export interface InsightDetailSelectionOption {
    type: InsightDetailType.SELECTION;
    component: React.FunctionComponent<InsightDetailSelectionProps>;
}

export type InsightDetailOption =
    | InsightDetailViewOption
    | InsightDetailSelectionOption;

export type InsightDetailProps = InsightDetailSelectionProps;
